// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-card {
  padding: 30px;
  margin: 30px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1254901961);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.profile-sidebar .k-button-group {
  box-shadow: none;
}
.profile-sidebar .k-button-group .k-button {
  margin-inline-start: 0px !important;
  border-color: #005596;
}
.profile-sidebar .k-button-group .k-button::before, .profile-sidebar .k-button-group .k-button::after {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.profile-sidebar .k-toggle-button {
  color: #005596;
}
.profile-sidebar .k-state-selected {
  color: white;
  background: #005596;
  opacity: unset !important;
}
.profile-sidebar .k-state-selected::before {
  opacity: 0;
}
.profile-sidebar .k-button {
  font-family: "proxima-nova", sans-serif;
  text-decoration: none;
  text-transform: capitalize;
  font-size: medium;
  justify-content: flex-start;
  border-color: unset;
}
.profile-sidebar :not(.k-state-selected) {
  background-color: transparent;
  border: none;
}

.profile-content {
  padding-left: 16px;
}

@media screen and (max-width: 760px) {
  .profile-sidebar {
    width: 100%;
  }
  .profile-content {
    width: 100%;
  }
}
@media screen and (min-width: 761px) {
  .profile-sidebar {
    width: 30%;
  }
  .profile-content {
    width: 70%;
  }
  .profile-buttongroup {
    max-width: 250px;
  }
}
.d-col {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/account/components/manage/manage.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACJ;;AAGI;EACI,gBAAA;AAAR;AACQ;EAEI,mCAAA;EACA,qBAAA;AACZ;AACQ;EACI,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;AACZ;AAEI;EACI,cAAA;AAAR;AAEI;EACI,YAAA;EACA,mBAAA;EACA,yBAAA;AAAR;AAEI;EACI,UAAA;AAAR;AAEI;EACI,uCAAA;EACA,qBAAA;EACA,0BAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;AAAR;AAGI;EACI,6BAAA;EACA,YAAA;AADR;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI;IACI,WAAA;EADN;EAGE;IACI,WAAA;EADN;AACF;AAGA;EACI;IACI,UAAA;EADN;EAGE;IACI,UAAA;EADN;EAGE;IACI,gBAAA;EADN;AACF;AAIA;EACI,aAAA;EACA,sBAAA;AAFJ","sourcesContent":[".profile-card {\n    padding: 30px;\n    margin: 30px;\n    box-shadow: 0 3px 6px #00000020;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.profile-sidebar {\n    .k-button-group {\n        box-shadow: none;\n        .k-button {\n            -webkit-margin-start: 0px !important;\n            margin-inline-start: 0px !important;\n            border-color: #005596;\n        }\n        .k-button::before, .k-button::after{\n            top: 0px;\n            right: 0px;\n            bottom: 0px;\n            left: 0px;\n        }\n    }\n    .k-toggle-button {\n        color: #005596;\n    }\n    .k-state-selected {\n        color: white;\n        background: #005596;\n        opacity: unset !important;\n    }\n    .k-state-selected::before {\n        opacity: 0;\n    }\n    .k-button {\n        font-family: \"proxima-nova\", sans-serif;\n        text-decoration: none;\n        text-transform: capitalize;\n        font-size: medium;\n        justify-content: flex-start;\n        border-color: unset;\n    }\n\n    :not(.k-state-selected) {\n        background-color: transparent;\n        border: none;\n    }\n}\n.profile-content {\n    padding-left: 16px;\n}\n\n@media screen and (max-width: 760px) {\n    .profile-sidebar {\n        width: 100%;\n    }\n    .profile-content {\n        width: 100%;\n    }\n}\n@media screen and (min-width: 761px) {\n    .profile-sidebar {\n        width: 30%;\n    }\n    .profile-content {\n        width: 70%;\n    }\n    .profile-buttongroup{\n        max-width: 250px;\n    }\n}\n\n.d-col {\n    display: flex;\n    flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
